import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import {
  CourseService,
  SingleItem,
} from '../../../../../services/course.service';

@Component({
  selector: 'app-lessions-id',
  templateUrl: './lessions-id.component.html',
  styleUrl: './lessions-id.component.scss',
})
export class LessionsIdComponent {
  courseId: string | null =
    inject(ActivatedRoute).snapshot.paramMap.get('courseId');

  lessonId: string | null =
    inject(ActivatedRoute).snapshot.paramMap.get('lessonId');

  constructor(
    protected courseService: CourseService,
    protected router: Router
  ) {}

  ngOnInit() {
    if (!this.courseId) {
      console.error('No course id');
      return;
    }

    if (!this.lessonId) {
      console.error('No lesson id');
      return;
    }

    combineLatest([
      this.courseService.listCourses([this.courseId]),
      this.courseService.listLessons([this.lessonId]),
    ]).subscribe(([courses, lessons]) => {
      const lesson = lessons.find((lesson) => lesson.id === this.lessonId);

      if (!lesson) {
        console.error('No lesson found');
        return;
      }

      this.courseService.listItems(lesson.items).subscribe((items) => {});
    });
  }

  get items() {
    return this.courseService.items$.value;
  }

  get lesson() {
    return this.courseService.lessions$.value.find(
      (lesson) => lesson.id === this.lessonId
    );
  }

  getText(item: SingleItem) {
    return item?.heading ?? item?.paragraph ?? 'Missing type in text type';
  }

  get froalaEditorOptions() {
    return {
      toolbarInline: true,
      toolbarButtons: [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'fontFamily',
        'fontSize',
        'textColor',
        'backgroundColor',
        'inlineClass',
        'inlineStyle',
        'link', // broken
        'lists',
        'align',
        'clearFormatting',
        'lineHeight',
        'table',
      ],
    };
  }
}
